import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    orderLoading: false,
    orderBaskets: null,
    orderBasketDetail: null,
    orderDetail: null,
    orderBasketLoading: false,
    orderListLoading: false,
    orderList: null,
    orderStatus: null,
    orderTransactions: null,
    orderDropdownData: null,
};

const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        setOrderLoading: (state, action) => {
            state.orderLoading = action.payload;
        },
        setOrderDetailedList: (state, action) => {
            state.orderDetailedList = action.payload;
        },
        setOrderDropdownData: (state, action) => {
            state.orderDropdownData = action.payload;
        },
        setOrderBaskets: (state, action) => {
            state.orderBaskets = action.payload;
        },
        setOrderBasketDetail: (state, action) => {
            state.orderBasketDetail = action.payload;
        },
        setOrderDetail: (state, action) => {
            state.orderDetail = action.payload;
        },
        setOrderBasketLoading: (state, action) => {
            state.orderBasketLoading = action.payload;
        },
        setOrderListLoading: (state, action) => {
            state.orderListLoading = action.payload;
        },
        setOrderList: (state, action) => {
            state.orderList = action.payload;
        },
        setOrderStatus: (state, action) => {
            state.orderStatus = action.payload;
        },
        setOrderTransactions: (state, action) => {
            state.orderTransactions = action.payload;
        },
    },
});

export const {
    setOrderBasketDetail,
    setOrderBasketLoading,
    setOrderBaskets,
    setOrderDetail,
    setOrderDetailedList,
    setOrderDropdownData,
    setRefreshingesr,
    setOrderList,
    setOrderListLoading,
    setOrderLoading,
    setOrderStatus,
    setOrderTransactions,
} = orderSlice.actions;
export default orderSlice.reducer;
